<template>
  <div v-if="show" class="bh-modal">
    <div class="bh-overlay" @click="$emit('close')" />

    <div class="bh-dialog" role="dialog" aria-modal="true" aria-label="Detail Benefit">
      <!-- HEADER -->
      <div class="bh-header">
        <div class="bh-header-left">
          <div class="bh-app-icon" aria-hidden="true">
            <img :src="data?.image_url" alt="" />
          </div>
          <div class="bh-title" v-html="data?.title" />
        </div>

        <button class="bh-close" type="button" aria-label="Close" @click="$emit('close')">
          <img :src="closeIconSrc" alt="" />
        </button>
      </div>

      <div class="bh-divider"></div>

      <!-- BODY -->
      <div class="bh-body">
        <!-- BENEFIT CARD (seperti gambar) -->
        <div class="bh-card">
          <div class="bh-benefit-list">
            <template v-for="(item, index) in parsedChild[0]?.child" :key="index">
              <div class="bh-benefit-item">
                <img :src="item?.image_url" alt="" class="bh-benefit-icon" />
                <div class="bh-benefit-content">
                  <div class="bh-benefit-title" v-html="item?.title" />
                  <div class="bh-benefit-desc" v-html="item?.description" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- (Opsional) kalau mau tambahin card “Channel yang akan anda dapatkan”, tinggal buka ini -->
        <div v-if="showChannels" class="bh-card bh-card--mt">
          <div class="bh-card-title">Channel yang akan anda dapatkan</div>

          <div class="bh-benefit-list">
            <div class="bh-benefit-item">
              <div class="bh-benefit-icon">
                <img :src="sportIconSrc" alt="" />
              </div>
              <div class="bh-benefit-content">
                <div class="bh-benefit-title">Sports</div>
                <div class="bh-benefit-desc">
                  V+ Sports (AFC Champions League, Shopee Cup, UEFA Nations League, Futsal, Bilyard, dan lainnya.
                </div>
              </div>
            </div>

            <div class="bh-benefit-item">
              <div class="bh-benefit-icon">
                <img :src="moviesIconSrc" alt="" />
              </div>
              <div class="bh-benefit-content">
                <div class="bh-benefit-title">Movies &amp; Entertainment</div>
                <div class="bh-benefit-desc">
                  MNC FTA, Vision+ Originals, Thrills, MTV, Cineedge, Kix, dan lainnya.
                </div>
              </div>
            </div>

            <div class="bh-benefit-item">
              <div class="bh-benefit-icon">
                <img :src="kidsIconSrc" alt="" />
              </div>
              <div class="bh-benefit-content">
                <div class="bh-benefit-title">Kids</div>
                <div class="bh-benefit-desc">Kids TV, Zoomoo</div>
              </div>
            </div>
          </div>
        </div>

        <!-- STEPS -->
        <div class="bh-section">
          <div class="bh-section-title" v-html="parsedChild[1]?.title" />
          <ol class="bh-steps">
            <li v-for="(item, index) in parsedChild[1]?.child" :key="index" v-html="item?.title" />
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitDetailModal',
  props: {
    show: { type: Boolean, default: false },
    // kalau mau sekalian tampilkan card "Channel yang akan anda dapatkan"
    showChannels: { type: Boolean, default: false },
    data: { type: Object, default: null },
  },
  data () {
    return {
      // webpack / vue-cli friendly
      closeIconSrc: require('../assets/icons/close2.svg'),

      sportIconSrc: require('../assets/icons/sport.svg'),
      moviesIconSrc: require('../assets/icons/movies.svg'),
      kidsIconSrc: require('../assets/icons/kids.svg'),
    }
  },
  watch: {
    show (val) {
      if (val) document.addEventListener('keydown', this.onKeydown)
      else document.removeEventListener('keydown', this.onKeydown)
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown (e) {
      if (e.key === 'Escape') this.$emit('close')
    }
  },
  computed: {
    parsedChild() {
      if (!this.data || !this.data.child) return null
      try {
        return JSON.parse(this.data.child)
      } catch (e) {
        return null
      }
    } 
  }
}
</script>

<style scoped>
.bh-modal {
  position: fixed;
  inset: 0;
  z-index: 99999;
}

.bh-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
}

.bh-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(920px, calc(100% - 32px));
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.25);
  overflow: hidden;
  max-height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
}

.bh-header {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bh-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bh-app-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bh-app-icon img {
  width: 22px;
  height: 22px;
  display: block;
}

.bh-title {
  font-weight: 800;
  color: #111827;
  font-size: 16px;
}

.bh-close {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  border-radius: 10px;
}
.bh-close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.bh-divider {
  height: 1px;
  background: #e5e7eb;
}

/* body scroll kalau konten panjang */
.bh-body {
  padding: 16px 18px 18px;
  overflow: auto;
}

/* Card benefit seperti screenshot */
.bh-card {
  background: #F5F6FA;
  border: 1px solid #d6dff4;
  border-radius: 12px;
  padding: 14px;
}

.bh-card--mt {
  margin-top: 14px;
}

.bh-card-title {
  font-weight: 800;
  color: #374151;
  font-size: 14px;
  margin-bottom: 10px;
}

/* list */
.bh-benefit-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.bh-benefit-item {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 12px;
  align-items: start;
}

.bh-benefit-icon {
  width: 24px;
  height: 24px;
}
.bh-benefit-icon img {
  width: 24px;
  height: 24px;
  display: block;
}

.bh-benefit-title {
  font-weight: 800;
  color: #374151;
  font-size: 15px;
  margin-bottom: 4px;
}

.bh-benefit-desc {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.35;
}

/* steps (nomor bulat seperti screenshot) */
.bh-section {
  margin-top: 16px;
}

.bh-section-title {
  font-weight: 800;
  color: #374151;
  margin-bottom: 10px;
  font-size: 14px;
}

.bh-steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 14px;
  counter-reset: step;
}

.bh-steps li {
  position: relative;
  padding-left: 38px;
  color: #4b5563;
  line-height: 1.35;
  font-size: 14px;
}

.bh-steps li::before {
  counter-increment: step;
  content: counter(step);
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid #d6dff4;
  background: #fff;
  color: #111827;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

@media (max-width: 600px) {
  .bh-body { padding: 12px 14px 14px; }
  .bh-title { font-size: 15px; }
  .bh-benefit-title { font-size: 14px; }
  .bh-benefit-desc { font-size: 13px; }
}
</style>
